import { useCallback } from 'react';
import { useCartStore } from '../../store/useCartStore';
import { cartService } from '../../services/cartService';
import { GlobalErrorHandler } from '../../errors';

export function useCartDiscountCode() {
  const discountCode = useCartStore((state) => state.discountCode);

  const applyDiscountCode = useCallback(async (code: string) => {
    const result = await cartService.applyDiscountCode(code);
    if (!result.ok) {
      GlobalErrorHandler.handle(result.error, {
        scope: 'cartDrawer',
        source: 'discount',
        userInitiated: true,
        correlationId: code
      });
    }
    return result;
  }, []);

  const removeDiscountCode = useCallback(async (code: string) => {
    const result = await cartService.removeDiscountCode(code);
    if (!result.ok) {
      GlobalErrorHandler.handle(result.error, {
        scope: 'cartDrawer',
        source: 'discount',
        userInitiated: true,
        correlationId: code
      });
    }
    return result;
  }, []);

  const clearDiscountCodes = useCallback(async () => {
    const result = await cartService.clearDiscountCodes();
    if (!result.ok) {
      GlobalErrorHandler.handle(result.error, {
        scope: 'cartDrawer',
        source: 'discount',
        userInitiated: true,
        correlationId: discountCode.code ?? undefined
      });
    }
    return result;
  }, [discountCode.code]);

  return { discountCode, applyDiscountCode, removeDiscountCode, clearDiscountCodes };
}
